<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-brand">
        <div class="footer-logo">ColorThinking</div>
        <p>让工具更简单</p>
        <span>© 2025 ColorThinking. All rights reserved.</span>
      </div>
      <div class="footer-section">
        <h3>产品</h3>
        <router-link v-for="p in pageProducts" :key="p.id" :to="`/home/${p.id}`">{{ p.name }}</router-link>
      </div>
      <div class="footer-section">
        <h3>支持</h3>
        <router-link to="/about">关于我们</router-link>
        <router-link to="/about">使用文档</router-link>
        <a href="mailto:contact@colorthinking.com">contact@colorthinking.com</a>
      </div>
    </div>
    <div class="footer-records">
      <a href="https://beian.miit.gov.cn/?f" target="_blank">沪ICP备2025122789号-1</a>
      <span class="police-record">
        <img src="../assets/police.png" class="record-icon" alt="">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31010602008824" rel="noreferrer" target="_blank">沪公网安备31010602008824号</a>
      </span>
    </div>
  </footer>
</template>

<script setup>
import { products } from '@/data/products'

const pageProducts = products.filter(p => p.page)
</script>

<style scoped>
.app-footer {
  margin-top: auto;
  padding: 2.5rem 2rem 1rem;
  background: #fff;
  border-top: 1px solid #e7ebf0;
}

.app-footer a {
  color: #666;
  text-decoration: none;
}

.app-footer a:hover {
  color: #2d85f0;
}

.footer-content {
  width: min(1180px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 2rem;
  text-align: left;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.footer-logo {
  color: #2d85f0;
  font-size: 1.18rem;
  font-weight: 800;
}

.footer-brand p {
  margin: 0;
  color: #4b5563;
  font-size: 0.86rem;
}

.footer-brand span {
  color: #8a94a3;
  font-size: 0.8rem;
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 0.38rem;
}

.footer-section h3 {
  margin: 0 0 0.15rem;
  color: #2c3e50;
  font-size: 0.88rem;
}

.footer-section a {
  font-size: 0.82rem;
}

.footer-records {
  width: min(1180px, 100%);
  margin: 1.2rem auto 0;
  padding-top: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #8a94a3;
  font-size: 0.78rem;
  border-top: 1px solid #edf0f4;
}

.police-record {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.record-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .app-footer {
    padding: 1.6rem 1.2rem 0.9rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 1rem;
    text-align: center;
  }

  .footer-records {
    flex-direction: column;
    gap: 0.45rem;
  }
}
</style>
